import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=1d6a3a9a&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
import style0 from "./Player.vue?vue&type=style&index=0&id=1d6a3a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a3a9a",
  null
  
)

export default component.exports